// extracted by mini-css-extract-plugin
export default {"container":"Product_container__GAqGs","products":"Product_products__M3k7e","menu":"Product_menu__mAczC","list":"Product_list__kLIOl","product":"Product_product__iAW7V"};